import { render, staticRenderFns } from "./morphology.vue?vue&type=template&id=6f6a7d28&scoped=true"
import script from "./morphology.vue?vue&type=script&lang=js"
export * from "./morphology.vue?vue&type=script&lang=js"
import style0 from "./morphology.vue?vue&type=style&index=0&id=6f6a7d28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6a7d28",
  null
  
)

export default component.exports